<template>
  <transition name="gp-fade">
    <div v-if="party.active" class="game-party">
      <div class="container">
      <div class="art">
        <img :src="party.game.coverArt" :alt="party.game.title" class="cover">
      </div>

      <div class="body">
        <div class="status">
          <span
            class="status-dot"
            :class="party.started ? 'live' : 'open'"
          ></span>
          <span class="status-text">{{ statusLabel }}</span>
        </div>

        <h2 class="headline">{{ headline }}</h2>

        <p class="subtext">{{ subtext }}</p>

          <div class="actions">
            <button v-ripple @click="joinLobby" class="gp-btn gp-btn--join">

              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none">
                <path d="M17 10H20M23 10H20M20 10V7M20 10V13" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M1 20V19C1 15.134 4.13401 12 8 12V12C11.866 12 15 15.134 15 19V20" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M8 12C10.2091 12 12 10.2091 12 8C12 5.79086 10.2091 4 8 4C5.79086 4 4 5.79086 4 8C4 10.2091 5.79086 12 8 12Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              Join Lobby
            </button>

            <button @click="stopParty" v-ripple class="gp-btn gp-btn--end">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none">
                <path d="M22 18V6C22 4.34315 20.6569 3 19 3H17C15.3431 3 14 4.34315 14 6V18C14 19.6569 15.3431 21 17 21H19C20.6569 21 22 19.6569 22 18Z" stroke="currentColor" stroke-width="1.5"/>
                <path d="M8 3H6C3.79086 3 2 4.79086 2 7V17C2 19.2091 3.79086 21 6 21H8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M14 12H6M6 12L9 9M6 12L9 15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              End Party
            </button>
          </div>
      </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'GameParty',

  components: {
  },

  watch: {
  },

  data: function(){
    return {

      party: {
                "active": false, //if there's a party or not
                "started":false, // wehther the lobby is still open to new players or ot
                "game":{}, //game details
                //sample game schema
                //"romName": "118",
                // "title": "Ghost of Tsushima",
                //"coverArt": "https://cdn.studio14a.com/QB/games/ghostoftus.jpg",
                // "id": "ghost-of-tsushima-directors-cut",
                // "console": "Native",
                // "tags": [
                // "RPG",
                //  "AAA",
                //   "beat-em-up"
                //],
                "players":[], //numbers of players who've joined
            }
    }
  },

  methods: {
      stopParty(){
          window.afetch(`/stopGameStream`)
      },
      joinLobby(){
        this.$router.push(`/theater?mode=game&id=${this.party.game.id}`)
      },
  },

  computed: {
    headline() {
      return "There's a party going on"
    },
    subtext() {
      const title = (this.party.game && this.party.game.title) || 'their game'
      const count = this.playerCount
      if (count === 1) {
        return `1 of your friends is playing ${title} right now, join the lobby to party up.`
      }
      if (count > 1) {
        return `${count} of your friends are playing ${title} right now, join the lobby to party up.`
      }
      return `Join the lobby to play ${title} with the homies.`
    },
    playerCount() {
      return Array.isArray(this.party.players) ? this.party.players.length : 0
    },
    statusLabel() {
      return this.party.started ? 'Lobby closed' : 'Lobby open'
    },
  },

  mounted: async function(){
      window.afetch('/gameParty').then(response => response.json()).then((data) => { this.party = data })
      this.$root.$on('gameParty', (x) => { this.party = x })
  }
}

</script>

<style lang="scss" scoped>
.game-party {
  position: relative;
  width: 100%;
  box-sizing: border-box;
  padding: 48px;
  margin-bottom: 48px;
  background: #141414;
  color: white;
}
.container{
  display: flex;
  align-items: center;
  gap: 20px;
}

.art {
  flex-shrink: 0;
  width: 180px;
  height: 250px;
  border-radius: 8px;
  overflow: hidden;
}

.cover {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.body {
  display: flex;
  flex-direction: column;
  gap: 7px;
  min-width: 0;
}

.status {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 6px;
}

.status-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  flex-shrink: 0;

  &.open {
    background: #00b894;
  }

  &.live {
    background: #fdcb6e;
  }
}

.status-text {
  font-size: 8px;
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: white;
}

.headline {
  margin: 0;
  font-weight: 600;
  font-size: 20px;
  line-height: 1.2;
  color: white;
}

.subtext {
  margin: 0;
  max-width: 440px;
  font-size: 13px;
  line-height: 1.45;
  color: #9aa0a6;
}

.actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  margin-top: 20px;
}

.gp-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 10px 15px;
  border-radius: 5px;
  font-size: 11px;
  cursor: pointer;
  white-space: nowrap;
  color: white;
}

.gp-btn--join {
  border: 1px solid #0984e3;
  background-color: rgba(9, 132, 227, 0.5);

  &:hover {
    background-color: rgba(9, 132, 227, 0.7);
  }
}

.gp-btn--end {
  border: 1px solid #d63031;
  background-color: rgba(214, 48, 49, 0.5);

  &:hover {
    background-color: rgba(214, 48, 49, 0.7);
  }
}

.gp-fade-enter-active,
.gp-fade-leave-active {
  transition: opacity 0.2s ease;
}

.gp-fade-enter,
.gp-fade-leave-to {
  opacity: 0;
}
</style>
